<template>
  <div class="flex items-center gap-2">
    <p class="font-semibold max-md:text-sm">{{ label }}</p>

    <label :for="name" class="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        v-model="isChecked"
        :true-value="true"
        :false-value="false"
        :name="name"
        :id="name"
        @change="emitValue"
        class="sr-only peer"
      />
      <div
        class="w-11 h-6 bg-[#E2E2E2] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-color"
      ></div>
    </label>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  name: { type: String, required: true },
  label: { type: String, required: true },
  property: { type: Number, required: true },
  dataType: { type: Number, required: true },

  // ✅ добавь
  value: { type: [Boolean, String, Number], default: false },
});

const emit = defineEmits(['valueChanged']);

const toBool = v => v === true || v === 'true' || v === 1 || v === '1' || v === 'on' || v === 'yes';

const isChecked = ref(toBool(props.value));

// ✅ если родитель когда-то передаст новое значение — синхронизируем
watch(
  () => props.value,
  v => (isChecked.value = toBool(v)),
);

const emitValue = () => {
  emit('valueChanged', {
    type: 'boolean',
    property: props.property,
    value: isChecked.value,
  });
};
</script>
